/**
 * Copyright © 2024-2026 Entangled Harmony Labs, LLC
 * All Rights Reserved. Proprietary and Confidential.
 */

import { XCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';

interface SubscriptionCancelProps {
  onContinue: () => void;
  onTryAgain: () => void;
}

export const SubscriptionCancel = ({ onContinue, onTryAgain }: SubscriptionCancelProps) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-slate-100 p-4">
      <Card className="max-w-md w-full text-center">
        <CardHeader>
          <div className="mx-auto mb-4 w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center">
            <XCircle className="h-10 w-10 text-gray-500" />
          </div>
          <CardTitle className="text-2xl">Payment Cancelled</CardTitle>
          <CardDescription>
            No worries! Your payment was not processed.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            You can continue using Guituitive with your current plan, or try upgrading again when you're ready.
          </p>

          <div className="space-y-2">
            <Button onClick={onTryAgain} className="w-full">
              Try Again
            </Button>
            <Button variant="outline" onClick={onContinue} className="w-full">
              Continue with Free Plan
            </Button>
          </div>

          <p className="text-xs text-muted-foreground">
            Have questions? Contact us at support@guituitive.com
          </p>
        </CardContent>
      </Card>
    </div>
  );
};
